module.exports = __webpack_public_path__ + "img/Logo_Viadeo.ef502d5c.png";